"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var __1 = require("../..");
var ColumnsMenu = function (_a) {
    var columns = _a.columns, hiddenColumns = _a.hiddenColumns, canSortColumns = _a.canSortColumns, _b = _a.disabled, disabled = _b === void 0 ? false : _b, onHideOrShow = _a.onHideOrShow, onSort = _a.onSort;
    var mappedOptions = columns.map(function (column) { return ({
        label: column.label,
        value: column.id,
        trailingIcon: column.canHide ? (hiddenColumns.includes(column.id) ? 'visibility_off' : 'visibility') : undefined,
    }); });
    return (react_1.default.createElement(__1.Dropdown, { icon: "view_week", keepOpen: true, disabled: disabled, options: mappedOptions, onChange: function (option) {
            var column = columns.find(function (column) { return column.id === option.value; });
            if (column === null || column === void 0 ? void 0 : column.canHide) {
                onHideOrShow(option.value, hiddenColumns.includes(option.value));
            }
        }, placeholder: "Columns", sortable: canSortColumns, onSort: onSort
            ? function (sortedOptions) {
                onSort(sortedOptions.map(function (option) { return columns.find(function (column) { return column.id === option.value; }); }));
            }
            : undefined, value: null, placement: "bottom-end", fallbackPlacement: "bottom-start" }));
};
exports.default = ColumnsMenu;
